import { ActionBar, ChakraBox, FAIconName } from '@equip.health/ui';

interface RailSectionErrorFallbackProps {
  id: string;
  label: string;
}

export const RailSectionErrorFallback = ({
  id,
  label,
}: RailSectionErrorFallbackProps) => (
  <ChakraBox width="100%">
    <ActionBar
      barIcon={FAIconName.exclamationTriangleRegular}
      id={id}
      text={`We were unable to load ${label}. Please try again later.`}
      variant="critical"
    />
  </ChakraBox>
);
